import { Component, OnInit, ViewChild } from '@angular/core';
import { Router,ActivatedRoute }from '@angular/router';
import { I9Service } from 'src/app/services/i9-service';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/data/models/app-state';
import { getI9SectionOneInfoAction, setPreparerInfoAction, setWorkAuthPreparerInfoAction } from 'src/app/app-state/actions/i9-section-one.actions';
import { I9PreparerInfoComponent } from 'src/app/modules/shared/i9-preparer-info/i9-preparer-info.component';
import { I9FormDetailsComponent } from 'src/app/modules/shared/i9-form-details/i9-form-details.component';
import { ToastrService } from 'ngx-toastr';
import * as I9SectionOneSelector  from 'src/app/app-state/selectors/i9-section-one.selector';
import moment from 'moment';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-create-i9-form',
  templateUrl: './create-i9-form.component.html',
  styleUrls: ['./create-i9-form.component.scss']
})
export class CreateI9FormComponent implements OnInit {
  isPreparer = '0';
  editingForm: boolean = false;
  agreeCheckboxSelection:boolean = false;
  beneficiaryId:string;
  companyId;
  i9FormId;
  I9BeneficiaryDetails;
  beneSignature: string = '';
  displayNotice: boolean = false;
  antiDiscriminatoryData : string = '';
  @ViewChild(I9PreparerInfoComponent) preparerComponent;
  @ViewChild(I9FormDetailsComponent) formDetailsComponent;
  isEditEnabled:boolean=true;
  isEdit:boolean=false;
  isPreparerExisting = false;
  preparerSignature: any;
  isUploadPrepSignatureNeeded = false;

  constructor(private i9Service:I9Service,
    private activatedRoute: ActivatedRoute,
    private toasterService: ToastrService,
    private router: Router,
    private store: Store<AppState>
  ) { 
      this.activatedRoute.queryParams.subscribe(params => {
        this.beneficiaryId = params['beneficiaryId'];
        this.companyId = params['companyId'];
        this.i9FormId = params['i9FormId'];
        if(params['edit'] == 0)
          this.isEditEnabled = false;
    });
  }

  ngOnInit() {
    this.store.dispatch(new getI9SectionOneInfoAction({
      i9FormId: this.i9FormId, 
      companyId: this.companyId
    }));
    this.store.pipe(select(I9SectionOneSelector.selectI9SectionOne)).subscribe( state =>{
      if(state){
        this.I9BeneficiaryDetails = state || null;
        this.isPreparer = (state?.i9WorkAuthPreparerInfo?.preparerInfo)? '1' : '0'; 
        this.isPreparerExisting = (state?.i9WorkAuthPreparerInfo?.preparerInfo)? true : false;
        this.agreeCheckboxSelection = state.isAntiDiscrAccpt; 
        if(state && state.statusCode){
          this.isEditEnabled = state.statusCode !== "SEC1COMPLTD";
        }
      }
    });
    this.loadSignature();
    this.getAntiDiscriminatoryData();
  }

  loadSignature(){
    this.i9Service.getBeneficiarySignature(this.beneficiaryId).subscribe(data => {
      this.beneSignature = data['signImage'] || '';
    });
  }

  getAntiDiscriminatoryData(){
    this.i9Service.getI9DiscrimintaionNotice().subscribe(data => {
      this.antiDiscriminatoryData = data['content'] || '';
    });
  }

  showNotice(){
    this.displayNotice = true;
  }

  handleEdit(){   
    this.isEdit=true;
   }

   saveSection1Info(){    
    debugger
    this.I9BeneficiaryDetails.isAntiDiscrAccpt = true;
    this.i9Service.postI9Section1Info(this.companyId, this.i9FormId, this.I9BeneficiaryDetails).subscribe(data => {
       this.toasterService.success("Data saved successfully!!", 'Success');
       //this.isEdit = false;
       this.isEditEnabled = false;
       this.store.dispatch(new getI9SectionOneInfoAction({
        i9FormId: this.i9FormId, 
        companyId: this.companyId
      }))
      if(this.isUploadPrepSignatureNeeded){
        this.uploadPreparerSignature();
      }      
    });
  }

  uploadPreparerSignature(){
    this.i9Service.uploadPreparerSignature(this.companyId, this.i9FormId,this.preparerSignature).subscribe((response) => {
      if (response['status'] === 200) {        
        this.store.dispatch(new getI9SectionOneInfoAction({
          i9FormId: this.i9FormId, 
          companyId: this.companyId
         })); 
      }
   }); 
  }

  saveI9Section1(){    
    console.log("Entered save");
    if(!this.isEdit){
      return;
    }
    let prepFormValidity = false;
    if(this.preparerComponent?.preparerForm){
      this.preparerSignature = this.preparerComponent.signatureImageForm;
      if(!this.isPreparerExisting){
        this.isUploadPrepSignatureNeeded = true;
      }else{
        this.isUploadPrepSignatureNeeded = false;
      }
      prepFormValidity = this.preparerComponent.preparerForm.valid
    }else{
      prepFormValidity = true;
    }    
    if(prepFormValidity){      
      
      let val = this.formDetailsComponent.i9WorkAuthPreparerForm.value;
      let expDate = this.formDetailsComponent.i9WorkAuthPreparerForm.value?.expirationDate;

      let formatDate = (expDate) ? moment(expDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
      if(formatDate === 'Invalid date'){
        formatDate = expDate.split("-").reverse().join("-");
      }
      val.expirationDate = formatDate;

      this.I9BeneficiaryDetails.i9WorkAuthPreparerInfo = val;
      if(this.preparerComponent?.preparerForm){
        this.I9BeneficiaryDetails.i9WorkAuthPreparerInfo.preparerInfo = this.preparerComponent.preparerForm.value;
        let preparerSignDate = this.I9BeneficiaryDetails.i9WorkAuthPreparerInfo.preparerInfo.preparerSignDate;
        let formatDate = (preparerSignDate) ? moment(preparerSignDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        if(formatDate === 'Invalid date'){
          formatDate = preparerSignDate.split("-").reverse().join("-");
        }

        this.I9BeneficiaryDetails.i9WorkAuthPreparerInfo.preparerInfo.preparerSignDate = formatDate;
      }else{
        this.I9BeneficiaryDetails.i9WorkAuthPreparerInfo.preparerInfo = null;
      }
    }
    console.log("Exit save");
    this.saveSection1Info();
  }

  submitI9Section1(){
    if(!this.beneSignature){
      CustomErrorToastComponent.showErrorToast(this.toasterService, 'Please upload your signature to submit the form');
      return;      
    }
    if(this.agreeCheckboxSelection){
      this.i9Service.updateI9Status(this.i9FormId, 'SEC1COMPLTD').subscribe(data => {
        if(data.status == 200 ){
          this.toasterService.success(data.message, 'Success');
          this.isEdit = false;
          this.isEditEnabled = false;
          //this.router.navigate(['beneficiary-landing/myforms']);
        }
      });  
    }     
  }

  cancelI9(){
    this.store.dispatch(new getI9SectionOneInfoAction({
      i9FormId: this.i9FormId, 
      companyId: this.companyId
    }));
    this.isEdit = false;
    this.router.navigate(['beneficiary-landing/myforms']);
  }

}
